.editColumnsContainer {
  position: relative;
  display: inline-block;
}

.editColumnsButton {
  display: flex;
  align-items: center;
  column-gap: 6px;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 8px;
  margin-left: 8px;
  @include themify($themes) {
    border: 1px solid themed("neutral-secondary");
    background-color: themed("background_actvie_tab");
  }
  white-space: nowrap;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: background-color 0.25s ease-out;
  font-size: 14px;
  font-weight: 500;
  
  &:not(.disabled):hover,
  &.filterIsOpen {
    transition: background-color 0.25s ease-in;
    @include themify($themes) {
      background-color: rgba(themed("neutral-secondary"), 0.5);
    }
  }

  &.disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.3;
  }
}

.editColumnsDropdown {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 8px;
  z-index: 1000;
  min-width: 320px;
  max-width: 340px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  border: 1px solid #e5e7eb;
  padding: 0;
  display: flex;
  flex-direction: column;
  font-size: 14px;

  @include themify($themes) {
    background: themed("background_primary");
    color: themed("neutral-primary");
    border: 1px solid themed("neutral-secondary");
    box-shadow: 0 8px 24px themed("shadow");

    @include dark-mode() {
      background: themed("main-secondary");
      color: themed("main-primary");
      border: 1px solid themed("neutral-secondary");
      box-shadow: 0 8px 24px themed("shadow");
    }
  }

  .searchBar {
    padding: 12px 16px 0 16px;
  }

  .dropdownContent {
    padding: 0 16px 0 16px;
    max-height: 400px;
    overflow-y: auto;
    @include themify($themes) {
      @include dark-mode() {
        background: themed("main-secondary");
      }
    }
  }

  .divider {
    height: 1px;
    margin: 4px 4px;
    @include themify($themes) {
      background: themed("neutral-secondary");
    }
  }

  .checkboxRow {
    display: flex;
    align-items: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    user-select: none;
    position: relative;
    height: 40px;

    > div {
      height: 100%;
    }
    @include themify($themes) {
      &:hover {
        background: themed("background_secondary");
      }
      @include dark-mode() {
        background: transparent;
      }
    }

    &.dragging {
      @include themify($themes) {
        background-color: themed("brand-secondary");
        border: 1px dashed themed("brand-primary");

        @include dark-mode() {
          background-color: themed("brand-secondary");
          border: 1px dashed themed("brand-primary");
        }
      }
    }

    .selectableCheckboxWrapper {
      margin-left: 6px;
      flex: 1;
    }

    .selectableCheckbox {
      width: 100%;

      > p {
        margin: 6px 0;
      }
    }

    .editNameIcon {
      opacity: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      margin-right: 5px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;

      @include themify($themes) {
        color: themed("neutral-primary");
        &:hover {
          background: themed("neutral-tertiary");
        }
        @include dark-mode() {
          color: themed("main-primary");
          &:hover {
            background: themed("neutral-secondary");
          }
        }
      }
    }

    &:hover .editNameIcon {
      opacity: 1;
    }

    .inlineEditInput {
      margin: 0 8px 0 12px;
      min-width: 0;
      background: transparent !important;

      input,
      input:focus,
      input:active {
        background-color: transparent;
        border: none;
        box-shadow: none;
        outline: none;
        min-height: 0;
        height: auto;
        padding: 4px 0;
        font-size: 14px;
        font-weight: normal;
        @include themify($themes) {
          border-bottom: 1px dashed themed("brand-primary");
        }
      }
    }

    .editActions {
      display: flex;
      align-items: center;
      margin-right: 5px;
      white-space: nowrap;

      .confirmEditIcon,
      .cancelEditIcon {
        cursor: pointer;
        margin-left: 8px;

        &:hover {
          background-color: rgba(0, 0, 0, 0.05);

          @include themify($themes) {
            @include dark-mode() {
              background-color: rgba(255, 255, 255, 0.1);
            }
          }
        }
      }

      .confirmEditIcon {
        color: #4caf50;

        &.disabled {
          color: #9e9e9e;
          cursor: not-allowed;
          opacity: 0.5;

          &:hover {
            background-color: transparent;
          }
        }
      }

      .cancelEditIcon {
        color: #f44336;
      }
    }

    &.selectAll {
      margin: 5px 0 2px 0;
    }
  }

  .dropdownFooter {
    padding: 10px 16px 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 12px 12px;
    font-size: 13px;

    @include themify($themes) {
      background: themed("background_secondary");
      border-top: 1px solid themed("neutral-secondary");
      color: themed("neutral-primary");
      .selectedCount {
        color: themed("main-primary");
      }

      @include dark-mode() {
        background: themed("main-secondary");
        border-top: 1px solid themed("neutral-secondary");
        color: themed("main-primary");
        .selectedCount {
          color: themed("brand-primary");
        }
      }
    }
  }
}

.noSearchResults {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  padding: 16px 0;
  text-align: center;
}

.footerActions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.resetLink {
  cursor: pointer;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
}

.dragHandleIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  cursor: grab;
}

.customInputWrapper {
  flex: 1;
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;
}

.inputContainer {
  background-color: transparent;
  border: none;
  box-shadow: none;
  outline: none;

  &:focus-within {
    background-color: transparent;
    border: none;
    box-shadow: none;
    outline: none;
  }
}
